import { useTime } from "@/app/application/TimeContext";
import { Translate } from "@/app/application/Translate";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import dayjs from "dayjs";
import { useField } from "formik";

const NativeDateTimeField = ({ label, id, ...props }) => {
	const theme = useTheme();
	const [field, meta, helpers] = useField(props);
	const { timezone } = useTime();

	const hasError = meta.touched && Boolean(meta.error);

	const inputValue = field.value
		? dayjs(field.value).tz(timezone).format("YYYY-MM-DDTHH:mm")
		: "";

	const handleChange = (e) => {
		const raw = e.target.value;
		if (!raw) {
			helpers.setValue("");
			return;
		}
		const zoned = dayjs.tz(raw, "YYYY-MM-DDTHH:mm", timezone);
		helpers.setValue(zoned.toISOString());
	};

	return (
		<div className="input-container">
			<Typography
				component="label"
				htmlFor={id}
				variant="body2"
				sx={{
					color: "text.secondary",
					mb: 0.5,
					display: "block",
					cursor: "pointer",
				}}
			>
				<Translate String={props.name}>{label}</Translate>
			</Typography>
			<input
				id={id}
				type="datetime-local"
				value={inputValue}
				onChange={handleChange}
				onBlur={field.onBlur}
				style={{
					width: "100%",
					padding: "8px 12px",
					borderRadius: 8,
					border: "1px solid",
					borderColor: hasError
						? theme.palette.error.main
						: theme.palette.divider,
					backgroundColor: theme.palette.background.paper,
					color: theme.palette.text.primary,
					fontSize: "1rem",
				}}
				{...props}
			/>
			{hasError && (
				<Typography
					variant="caption"
					sx={{ color: "error.main", mt: 0.5, display: "block" }}
				>
					{meta.error}
				</Typography>
			)}
		</div>
	);
};

export default NativeDateTimeField;
